// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import 'whatwg-fetch'

import router from '@/router'
import store from '@/store'
import loader from '@/components/main/loader/Loader'
import '@/filters'
import globalMixins from '@/mixins'
import getExternalQuery from '@/functions/getExternalQuery'
import dynamicContent from '@/directives/dynamicContent'

import smoothscroll from 'smoothscroll-polyfill'
import Fragment from 'vue-fragment'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueMq from 'vue-mq'
import App from './App'
import config from 'config'
import axios from 'axios'
import Sticky from 'vue-sticky-directive'
import '@/scss/sungevity/sungevity.scss'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  Vue,
  dsn: "https://83c6ad132471444d83d78c9e08731bed@o557955.ingest.sentry.io/6276892",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router)
    }),
  ],
  environment: window.location.host,
  // Set tracesSampleRate to .1 in prod to capture 10%
  // of transactions for performance monitoring in production.
  // Sampling enables representative data without overwhelming either
  // your system or your Sentry transaction quota.
  tracesSampleRate: window.location.host.indexOf('quote.sungevity') > -1 ? 0.1 : 1,
  logErrors: true, //call original Vue's logError function as well.
});

smoothscroll.polyfill()

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(Fragment.Plugin)
Vue.mixin(globalMixins)
Vue.use(VueMq, {
  breakpoints: {
    xs: 0,
    sm: 320,
    md: 768,
    lg: 1024,
    xl: Infinity,
  },
})
Vue.use(Sticky)
Vue.config.productionTip = false

store.commit('SET_EXTERNAL_QUERY', getExternalQuery())

Vue.$http = axios.create({
  baseURL: config.endpoints.api,
})

Vue.component('loader', loader)
Vue.directive('dynamic-content', dynamicContent)

/* eslint-disable no-new */
new Vue({
  mixins: [globalMixins],
  router,
  store,
  components: {
    App,
  },
  validations: {},
  render: (h) => h(App),
}).$mount('#app')
